/**
 * Environment configuration and API detection
 */
import { logger } from '../utils/logger';

/**
 * Determines API base URL based on environment
 */
const getApiBaseUrl = (): string => {
    logger.info(`🔍 Detectando ambiente - hostname: ${window.location.hostname}, port: ${window.location.port}`);
    logger.info(`🔍 DEV: ${import.meta.env.DEV}, PROD: ${import.meta.env.PROD}`);
    logger.info(`🔍 VITE_API_BASE_URL: ${import.meta.env.VITE_API_BASE_URL}`);

    if (import.meta.env.VITE_API_BASE_URL && import.meta.env.VITE_API_BASE_URL.trim() !== '') {
        logger.info(`🎯 Usando URL da variável de ambiente: ${import.meta.env.VITE_API_BASE_URL}`);
        return import.meta.env.VITE_API_BASE_URL;
    }

    if (import.meta.env.DEV) {
        logger.info('🎯 Usando proxy local para API (evitando CORS em desenvolvimento)');
        return '';
    } else {
        logger.info('🎯 Usando URL relativa em produção (rewrites)');
        return '';
    }
};

export const ENV_CONFIG = {
    APP_ENV: import.meta.env.VITE_APP_ENV || 'development',
    GEOCODE_API_KEY: import.meta.env.VITE_GEOCODE_API_KEY,
    API_BASE_URL: getApiBaseUrl(),

    get DEBUG_API_URL() {
        const url = getApiBaseUrl();
        if (this.DEBUG_MODE) {
            logger.log('🔧 ENV_CONFIG: API_BASE_URL =', url || '(URL relativa - usando proxy)');
            logger.log('🔧 ENV_CONFIG: hostname =', window.location.hostname);
            logger.log('🔧 ENV_CONFIG: DEV =', import.meta.env.DEV);
            logger.log('🔧 ENV_CONFIG: VITE_API_BASE_URL =', import.meta.env.VITE_API_BASE_URL);
        }
        return url;
    },

    IS_DEVELOPMENT: import.meta.env.DEV,
    IS_PRODUCTION: import.meta.env.PROD,
    IS_DEV_SERVER: import.meta.env.DEV && (import.meta.env.VITE_APP_ENV === 'development'),
    BASE_URL: import.meta.env.BASE_URL,
    DEBUG_MODE: import.meta.env.DEV || import.meta.env.VITE_APP_ENV === 'development' || import.meta.env.VITE_FORCE_DEBUG === 'true',

    DEV_SERVER: {
        HOST: true,
        PORT: 5173,
        NETWORK_ACCESS: true,
    },
} as const;

// Environment utilities
export const isDevEnvironment = () => ENV_CONFIG.IS_DEV_SERVER || ENV_CONFIG.APP_ENV === 'development';
export const isProdEnvironment = () => ENV_CONFIG.IS_PRODUCTION && ENV_CONFIG.APP_ENV === 'production';
export const isDebugMode = () => ENV_CONFIG.DEBUG_MODE;
export const hasNetworkAccess = () => ENV_CONFIG.DEV_SERVER.NETWORK_ACCESS && isDevEnvironment();

// Log configuration in development only
if (isDevEnvironment()) {
    logger.log('Environment Config:', {
        APP_ENV: ENV_CONFIG.APP_ENV,
        IS_DEVELOPMENT: ENV_CONFIG.IS_DEVELOPMENT,
        IS_PRODUCTION: ENV_CONFIG.IS_PRODUCTION,
        IS_DEV_SERVER: ENV_CONFIG.IS_DEV_SERVER,
        DEBUG_MODE: ENV_CONFIG.DEBUG_MODE,
        BASE_URL: ENV_CONFIG.BASE_URL,
        HAS_API_KEY: !!ENV_CONFIG.GEOCODE_API_KEY,
        NETWORK_ACCESS: hasNetworkAccess(),
        DEV_SERVER: ENV_CONFIG.DEV_SERVER,
    });

    if (hasNetworkAccess()) {
        logger.log('🌐 Network Access: Server configured to accept external connections');
        logger.log('Mobile Access: Connect your device to the same network and use the Network URL shown in terminal');
    }
}

export default ENV_CONFIG;
